import { render, staticRenderFns } from "./AppExpansionPanel.vue?vue&type=template&id=e97ed27a&scoped=true&"
import script from "./AppExpansionPanel.vue?vue&type=script&lang=js&"
export * from "./AppExpansionPanel.vue?vue&type=script&lang=js&"
import style0 from "./AppExpansionPanel.vue?vue&type=style&index=0&id=e97ed27a&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e97ed27a",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SvgIconDownArrow: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/svg/IconDownArrow.vue').default})
